import { render, staticRenderFns } from "./EditPageCommercialTerms.vue?vue&type=template&id=58e3e0bd"
import script from "./EditPageCommercialTerms.vue?vue&type=script&lang=js"
export * from "./EditPageCommercialTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports